import { AppSpinner } from '@common/components/appSpinner';
import { NotificationList } from '@common/components/utility';
import { ClientService, ImageService, IntakeService, ReservationService, VisitService, ZipCodeService } from "@common/services";
import { ConfigurationService } from '@common/services/configurationService';
import { anyPromiseTrackerTagsInProgress, componentUtility } from '@common/utils';
import classNames from 'classnames';
import { map } from 'lodash';
import React, { CSSProperties } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { NavBar } from './nav/NavBar';
export interface PageProps extends React.HTMLAttributes<HTMLElement> {
}

const Page = (props: React.PropsWithChildren<PageProps>) => {
    const { children } = props;
    const contentComponent = componentUtility.findByType(children, Content);
    const sideBarComponent = componentUtility.findByType(children, SideBar);
    const pageTitleComponent = componentUtility.findByType(children, PageTitle);

    if (!contentComponent) {
        throw new Error('Expected Page.Content child on Page component, not supplied');
    }

    const tags: string[] = [
        ...map(ConfigurationService.tags, (value) => value),
        ...map(ReservationService.tags, (value) => value),
        ...map(ClientService.tags, (value) => value),
        ...map(ImageService.tags, (value) => value),
        ...map(IntakeService.tags, (value) => value),
        ...map(ZipCodeService.tags, (value) => value),
        ...map(VisitService.tags, (value) => value)
    ];

    const spinnerOverride: CSSProperties =
    {
        margin: '350px auto 0',
        position: 'fixed',
        zIndex: 1050,
        overflow: 'show',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        width: '60px'
    };

    return (
        <>
            <NavBar />
            <NotificationList />

            {
                anyPromiseTrackerTagsInProgress(tags, 500) &&
                <>
                    <div className="overlay"></div>
                    <AppSpinner spinnerCSSOverride={spinnerOverride} />
                </>
            }
            <Container fluid className={classNames("page g-0", props.className)}>
                <Row className="g-0 row-eq-height page-row">
                    <Col md={sideBarComponent ? 10 : 12} className="main-column">
                        <div className="page-content pt-4 px-3">
                            {
                                pageTitleComponent ? pageTitleComponent : null
                            }
                            {contentComponent}
                        </div>
                    </Col>
                    {
                        sideBarComponent &&
                        <Col className="side-bar" md={2}>
                            {sideBarComponent}
                        </Col>
                    }
                </Row>
            </Container>

        </>
    )
};

export interface PageTitleProps {
    text?: string;
}

const PageTitle = (props: React.PropsWithChildren<PageTitleProps>) => {
    if (props.text) {
        return (
            <h1 className="page-header">{props.text}</h1>
        )
    }
    return (
        <>
            {props.children ? props.children : <></>}
        </>
    )
}

export interface SideBarProps {
    title?: string;
}

const SideBar = (props: React.PropsWithChildren<SideBarProps>) => {
    return (
        <>
            <div className="page-sideBar">
                {props.title &&
                    <h3 className="title">{props.title}</h3>
                }
                {props.children}
            </div>
        </>
    )
}

export interface ContentProps {
}

const Content = (props: React.PropsWithChildren<ContentProps>) => {
    return (
        <>
            {props.children}
        </>
    );
}

const PageComponent = Object.assign(Page, {
    SideBar,
    Content,
    PageTitle
});

export {
    PageComponent as Page
};
